import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import { SupplierPromotion } from '@softapps/wws/core';
import { inject, Injectable } from '@angular/core';
import { SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIER_PROMOTIONS } from '../artikelstamm.api';
import { SupplierPromotionQuery } from '../types/supplier-promotion.query';

@Injectable()
export class SupplierPromotionRepository extends ReadonlyHttpApiListRepository<
  SupplierPromotion[],
  SupplierPromotionQuery
> {
  constructor() {
    super(
      inject(ApiDataAccess),
      SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIER_PROMOTIONS
    );
  }

  override getLoadPathParams(params: SupplierPromotionQuery): Dictionary<unknown> {
    return { id: params.productId };
  }

  override getLoadQueryParams(params: SupplierPromotionQuery): Dictionary<unknown> {
    return { showAll: params.showAll };
  }
}
